let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("94h6f")).then(() => parcelRequire('9dHGm'));